import { Controller } from "@hotwired/stimulus"

// Same prompt for Generate and Download when the deck has unsaved edits.
const DIRTY_CONFIRM =
  "You have unsaved deck changes. Save them before continuing?\n\nOK = Save now\nCancel = Stay here"

export default class extends Controller {
  static targets = ["generateButton", "download"]
  static values = {
    running: { type: Boolean, default: false }
  }

  connect() {
    this.#syncGenerateLock()
  }

  runningValueChanged() {
    this.#syncGenerateLock()
  }

  confirmGenerate(event) {
    if (!this.#confirmSaveIfDirty(event)) return
    this.start()
  }

  confirmDownload(event) {
    this.#confirmSaveIfDirty(event)
  }

  start() {
    if (!this.hasGenerateButtonTarget) return
    this.generateButtonTarget.classList.add("is-loading")
    this.generateButtonTarget.setAttribute("aria-busy", "true")
  }

  // Returns true when the action may proceed; false when blocked (and maybe saving).
  #confirmSaveIfDirty(event) {
    const builder = this.#builderController()
    if (!builder?.isDirty?.()) return true

    const saveFirst = window.confirm(DIRTY_CONFIRM)
    event.preventDefault()
    event.stopImmediatePropagation()
    if (saveFirst) builder.submitSave()
    return false
  }

  #builderController() {
    const el = document.querySelector("[data-controller~='precon-builder']")
    if (!el) return null
    return this.application.getControllerForElementAndIdentifier(el, "precon-builder")
  }

  #syncGenerateLock() {
    if (!this.hasGenerateButtonTarget) return
    this.generateButtonTarget.disabled = this.runningValue
    this.generateButtonTarget.classList.toggle("is-loading", this.runningValue)
  }
}
